<template>
	<nav
		id="sidenav-main"
		class="navbar tw-p-0 navbar-vertical fixed-left navbar-expand-md navbar-light bg-white tw-h-screen tw-overflow-hidden"
	>
		<div class="container-fluid tw-flex tw-flex-col tw-h-screen tw-overflow-hidden">

			<!--Toggler-->
			<navbar-toggle-button @click.native="showSidebar"></navbar-toggle-button>

			<router-link
				to="/"
				class="navbar-brand tw-mx-5"
			>
				<img
					src="@/assets/img/easyval.png"
					width="300px"
					class="navbar-brand-img"
					alt="..."
				>
			</router-link>

			<slot name="mobile-right">
				<ul class="nav align-items-center d-md-none">
					<base-dropdown
						class="nav-item"
						menu-on-right
						tag="li"
						title-tag="a"
					>
						<a
							slot="title-container"
							class="nav-link nav-link-icon"
							href="#"
							role="button"
							aria-haspopup="true"
							aria-expanded="false"
						>
							<i class="ni ni-bell-55"></i>
						</a>

						<a
							class="dropdown-item"
							href="#"
						>Action</a>
						<a
							class="dropdown-item"
							href="#"
						>Another action</a>
						<div class="dropdown-divider"></div>
						<a
							class="dropdown-item"
							href="#"
						>Something else here</a>
					</base-dropdown>
					<base-dropdown
						class="nav-item"
						menu-on-right
						tag="li"
						title-tag="a"
					>
						<a
							slot="title-container"
							class="nav-link"
							href="#"
							role="button"
						>
							<div class="media align-items-center">
								<span class="avatar avatar-sm rounded-circle">
									<img
										alt="Image placeholder"
										src="img/theme/team-4.jpg"
									>
								</span>
							</div>
						</a>

						<div class=" dropdown-header noti-title">
							<h6 class="text-overflow m-0">Welcome!</h6>
						</div>
						<router-link
							to="/profile"
							class="dropdown-item"
						>
							<i class="ni ni-single-02"></i>
							<span>My profile</span>
						</router-link>
						<router-link
							to="/profile"
							class="dropdown-item"
						>
							<i class="ni ni-settings-gear-65"></i>
							<span>Settings</span>
						</router-link>
						<router-link
							to="/profile"
							class="dropdown-item"
						>
							<i class="ni ni-calendar-grid-58"></i>
							<span>Activity</span>
						</router-link>
						<router-link
							to="/profile"
							class="dropdown-item"
						>
							<i class="ni ni-support-16"></i>
							<span>Support</span>
						</router-link>
						<div class="dropdown-divider"></div>
						<a
							href="#!"
							class="dropdown-item"
						>
							<i class="ni ni-user-run"></i>
							<span>Logout</span>
						</a>
					</base-dropdown>
				</ul>
			</slot>

			<slot></slot>

			<div
				v-show="$sidebar.showSidebar"
				class="tw-flex-1 tw-flex tw-flex-col tw-overflow-hidden"
			>

				<div class="navbar-collapse-header d-md-none">
					<div class="row">
						<div class="col-6 collapse-brand">
							<router-link to="/">
								<img :src="logo">
							</router-link>
						</div>
						<div class="col-6 collapse-close">
							<navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
						</div>
					</div>
				</div>

				<ul class="navbar-nav tw-m-0 tw-overflow-y-auto tw-overflow-x-hidden tw-flex-1 scrollbar-y">
					<slot name="links"> </slot>
				</ul>

				<div class="tw-flex-none">
					<hr class="my-3">
					<h6 class="navbar-heading text-muted tw-mx-5">Documentación</h6>
					<ul class="navbar-nav mb-md-3">
						<li class="nav-item tw-px-5">
							<a
								class="nav-link"
								href="https://www.facebook.com/vlacconsulting/"
							>
								<i class="ni ni-spaceship"></i> Manual de Uso
							</a>
						</li>
						<li class="nav-item tw-px-5">
							<a
								class="nav-link"
								href="https://www.facebook.com/vlacconsulting/"
							>
								<i class="ni ni-palette"></i> Quienes Somos EasyVal
							</a>
						</li>
					</ul>
				</div>

				<div class="tw-mt-auto tw-flex-none tw-pb-5 tw-px-5">
					<slot name="actions"></slot>
				</div>
			</div>
		</div>
	</nav>
</template>
<script>
import NavbarToggleButton from '@/components/NavbarToggleButton'

export default {
	name: 'sidebar',
	components: {
		NavbarToggleButton
	},
	props: {
		logo: {
			type: String,
			default: 'img/brand/easyval.png',
			description: 'Sidebar app logo'
		},
		logo1: {
			type: String,
			default: 'img/brand/easyval.png',
			description: 'Sidebar app logo'
		},
		autoClose: {
			type: Boolean,
			default: true,
			description: 'Whether sidebar should autoclose on mobile when clicking an item'
		}
	},
	provide() {
		return {
			autoClose: this.autoClose
		};
	},
	methods: {
		closeSidebar() {
			this.$sidebar.displaySidebar(false)
		},
		showSidebar() {
			this.$sidebar.displaySidebar(true)
		}
	},
	beforeDestroy() {
		if (this.$sidebar.showSidebar) {
			this.$sidebar.showSidebar = false;
		}
	}
};
</script>
